export const messages = {
  create: {
    id: 'admin/promotions.form.conditions.utm.coupons.create',
  },
  editor: {
    title: {
      id: 'admin/promotions.form.conditions.utm.coupons.create.title',
    },
    name: {
      id: 'admin/promotions.form.conditions.utm.coupons.name',
    },
    utm: {
      utmSource: {
        id: 'admin/promotions.form.conditions.utm.source',
      },
      utmCampaign: {
        id: 'admin/promotions.form.conditions.utm.campaign',
      },
    },
    group: {
      title: {
        id: 'admin/promotions.form.conditions.utm.coupons.group',
      },
      subtitle: {
        id: 'admin/promotions.form.conditions.utm.coupons.group.subtitle',
      },
      aria: {
        id: 'admin/promotions.form.conditions.utm.coupons.group.aria-label',
      },
      limit: {
        id: 'admin/promotions.form.conditions.utm.coupons.group.limit',
      },
      moreInformation: {
        id: 'admin/promotions.form.conditions.utm.coupons.group.more-information',
      },
      coupons: {
        id: 'admin/promotions.form.utils.coupons',
      },
    },
    maxUsage: {
      title: {
        id: 'admin/promotions.form.conditions.utm.coupons.max-usage',
      },
      times: {
        id: 'admin/promotions.form.utils.times',
      },
      aria: {
        id: 'admin/promotions.form.conditions.utm.coupons.max-usage.aria-label',
      },
      helpText: {
        id: 'admin/promotions.form.conditions.utm.coupons.max-usage.help-text',
      },
    },
    create: {
      id: 'admin/promotions.utils.create',
    },
  },
  validation: {
    emptyName: {
      id: 'admin/promotions.form.validation.required',
    },
    specialChars: {
      id: 'admin/promotions.form.conditions.utm.coupons.validation.special-chars',
    },
    notAllowed: {
      id: 'admin/promotions.form.conditions.utm.coupons.validation.not-allowed',
    },
    unique: {
      id: 'admin/promotions.form.conditions.utm.coupons.validation.non-unique',
    },
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    lessThanEquals: {
      id: 'admin/promotions.form.validation.less-than-equals',
    },
    utmCampaign: {
      id: 'admin/promotions.form.conditions.utm.coupons.validation.empty-utm-campaign',
    },
    utmSource: {
      id: 'admin/promotions.form.conditions.utm.coupons.validation.empty-utm-source',
    },
  },
  toast: {
    success: {
      id: 'admin/promotions.form.conditions.utm.coupons.save.toast.success',
    },
    error: {
      id: 'admin/promotions.form.conditions.utm.coupons.save.toast.error',
    },
  },
  linked: { id: 'admin/promotions.form.conditions.utm.coupons.linked' },
}
